(function () {
 const initSliders = (section) => {
    const swiperEls = section.querySelectorAll(".products-tabs__layout");

    swiperEls.forEach((swiperEl, index) => {
      const swiperWrapper = swiperEl.querySelector(".products-tabs__slider");
      const slides = swiperEl.querySelectorAll(".products-tabs__item");

      if (!swiperWrapper || !slides || !slides.length) return;

      swiperEl.classList.add("swiper");
      swiperWrapper.classList.add("swiper-wrapper");
      slides.forEach((slide) => slide.classList.add("swiper-slide"));

      const tabId = swiperEl.getAttribute('data-products-tab-id');
      const navigationEl = section.querySelector(`.products-tabs__navigation[data-tab-id="${tabId}"]`);

      const nextBtns = section.querySelectorAll(
        `.products-tabs__navigation--${
          index + 1
        } .products-tabs__navigation-button-next`
      );
      const prevBtns = section.querySelectorAll(
        `.products-tabs__navigation--${
          index + 1
        } .products-tabs__navigation-button-prev`
      );

      const columns = Number(
        section.querySelector(".products-tabs").dataset.columns
      );

      // Breakpoint konfigürasyonları
      const columnsConfig = {
        6: {
          769: { slidesPerView: 3, },
          990: { slidesPerView: 4, },
          1360: { slidesPerView: 6, },
        },
        5: {
          769: { slidesPerView: 3, },
          1360: { slidesPerView: 5, },
        },
        4: {
          769: { slidesPerView: 2, },
          1200: { slidesPerView: 4, },
        },
        3: {
          769: { slidesPerView: 2, },
          990: { slidesPerView: 3, },
        },
        2: {
          769: { slidesPerView: 2, },
        },
        1: {
          769: { slidesPerView: 1, },
        },
      };

      sliderSettings = {
        slidesPerView: 1.5, 
        spaceBetween: 12, 
        speed: 800,
        allowTouchMove: true,
        loop: false, 
        observer: true,
        observeParents: true,
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          nextEl: Array.from(nextBtns),
          prevEl: Array.from(prevBtns),
          disabledClass: "swiper-button-disabled",
        },
        breakpoints: columnsConfig[columns],
        on: {
          init: function () {
            // Slider kurulduğunda okların görünürlüğünü denetle
            checkNavigation(this, navigationEl);
          },
          resize: function () {
            // Ekran boyutu değiştiğinde (Web/Mobil geçişlerinde) tekrar denetle
            checkNavigation(this, navigationEl);
          }
        }
      };

      new Swiper(swiperEl, sliderSettings);
    });
  };

  // Okların gösterilip gösterilmeyeceğini kontrol eden yeni yardımcı fonksiyon
  const checkNavigation = (swiperInstance, navigationEl) => {
    if (!navigationEl) return;
    
    // Swiper'ın o anki ekran genişliğinde aktif olan slidesPerView değerini alıyoruz
    const currentSlidesPerView = swiperInstance.params.slidesPerView;
    // Toplam orijinal kart sayısı (Klonlar hariç)
    const totalSlides = swiperInstance.slides.filter(slide => !slide.classList.contains('swiper-slide-duplicate')).length;

    // Eğer toplam kart sayısı, ekranda gösterilen kart sayısına eşit veya daha az ise okları gizle
    if (totalSlides <= currentSlidesPerView) {
      navigationEl.style.setProperty('display', 'none', 'important');
    } else {
      // Sadece aktif sekmeyse görünür kılmak için stili sıfırlıyoruz CSS yönetecek
      navigationEl.style.removeProperty('display');
    }
  };

  const toggleTab = (section) => {
    const tabsEls = section.querySelectorAll(".products-tabs__tab");
    const productsEls = section.querySelectorAll(".products-tabs__layout");

    tabsEls.forEach((tab) => {
      tab.addEventListener("click", (event) => {
        event.preventDefault();
        if (tab.classList.contains("active")) return;
        const tabId = tab.dataset.productsTabId;

        tabsEls.forEach((el) => {
          el.classList.remove("active");
        });

        productsEls.forEach((el) => {
          el.classList.remove("active");
        });

        const productsActiveEl = section.querySelector(
          `.products-tabs__layout[data-products-tab-id="${tabId}"]`
        );
        tab.classList.add("active");
        productsActiveEl.classList.add("active");

        // Sekme değiştiğinde Swiper'ın kendini yenilemesini tetikler (Loop kırılmalarını önler)
        if (productsActiveEl.swiper) {
          productsActiveEl.swiper.update();
        }

        section
          .querySelectorAll(".products-tabs__navigation")
          .forEach((navigation) => {
            navigation.classList.remove("active");
          });

        section
          .querySelectorAll(
            `.products-tabs__navigation[data-tab-id="${tabId}"]`
          )
          .forEach((navigation) => {
            navigation.classList.add("active");
          });
      });
    });
  };

  const initProductsTabs = (section) => {
    if (!section || !section?.classList.contains("products-tabs-section")) {
      return;
    }

    initSliders(section);
    toggleTab(section);
  };

  initProductsTabs(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initProductsTabs(event.target);
  });
})();